import { CellProps, Renderer } from 'react-table';
import { AlignRight } from '../AlignRight';

type RecordType = Record<string, any>;
const DecimalRenderer: Renderer<CellProps<RecordType>> = ({ value, row }) => (
  <AlignRight>{value == null ? null : value.toFixed(2)}</AlignRight>
);
export default DecimalRenderer;
